import React from 'react'
import { WhatsAppFloat } from './WhatsAppButton.elements'
import whatsappIcon from '../../images/whatsapp.jpeg' // ou png
import useShowStickyCta from '../StickyCta/useShowStickyCta'

const WhatsAppButton = () => {
  const raised = useShowStickyCta()

  return (
    <WhatsAppFloat
      href="https://wa.me/5519998164299"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Fale conosco no WhatsApp"
      $raised={raised}
    >
      <img src={whatsappIcon} alt="WhatsApp" />
    </WhatsAppFloat>
  )
}

export default WhatsAppButton
